<template>
  <div style="background-color: #f1f5f6;">
    <admin-header />
    <slot />
    <admin-footer />
  </div>
</template>

<script>
import AdminHeader from "../Admin/components/AdminHeader";
import AdminFooter from "../Admin/components/AdminFooter";

export default {
  components: {
    AdminFooter,
    AdminHeader
  },
  name: "admin-layout"
};
</script>

<style scoped></style>
